// size-chart.js - ATELIER PIERROT (portal + delegated)
(function(){
  "use strict";
  if (window.__sizeChartBound) return; // 二重読み込み防止
  window.__sizeChartBound = true;

  let lastTrigger = null;

  function portalToBody(modal){
    if (modal.__sc_portaled) return;
    modal.__sc_restore = { parent: modal.parentNode, next: modal.nextSibling };
    document.body.appendChild(modal);
    modal.__sc_portaled = true;
  }
  function restoreFromBody(modal){
    const s = modal.__sc_restore;
    if (!s) return;
    if (s.next) s.parent.insertBefore(modal, s.next);
    else s.parent.appendChild(modal);
    modal.__sc_portaled = false;
  }

  function openModalByTrigger(trigger){
    const root  = trigger.closest('.SizeChart-root');
    if (!root) return;
    const modal = root.querySelector('.SizeChart-modal');
    if (!modal) return;

    // transform の影響を避けるため body 直下に移動
    portalToBody(modal);

    lastTrigger = trigger;
    modal.setAttribute('aria-hidden','false');
    trigger.setAttribute('aria-expanded','true');
    document.documentElement.classList.add('sizechart-no-scroll');

    const dialog = modal.querySelector('.SizeChart-dialog');
    (dialog || modal).focus();
  }

  function closeModal(modal){
    if (!modal) return;
    modal.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('sizechart-no-scroll');

    if (lastTrigger){
      lastTrigger.setAttribute('aria-expanded','false');
      lastTrigger.focus();
      lastTrigger = null;
    }
    restoreFromBody(modal);
  }

  function getOpenModal(){
    return document.querySelector('.SizeChart-modal[aria-hidden="false"]');
  }

  // クリック（委譲）
  document.addEventListener('click', function(e){
    const trg = e.target.closest('.SizeChart-trigger');
    if (trg){
      e.preventDefault();
      openModalByTrigger(trg);
      return;
    }
    const toClose = e.target.closest('[data-close="true"]');
    if (toClose){
      const modal = e.target.closest('.SizeChart-modal') || getOpenModal();
      closeModal(modal);
    }
  }, true);

  // ESC キーで閉じる
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape'){
      const m = getOpenModal();
      if (m){ e.preventDefault(); closeModal(m); }
    }
  });
})();
